<template>
  <b-alert variant="info" show class="mb-0" v-if="quota">{{ quota }}</b-alert>
</template>
<script>
export default {
  data() {
    return {
      quota: null
    };
  },

  watch: {
    async "$i18n.locale"() {
      await this.storageInfo();
    }
  },

  async mounted() {
    await this.storageInfo();
  },

  methods: {
    async storageInfo() {
      if (navigator.storage && navigator.storage.estimate) {
        const quota = await navigator.storage.estimate();
        // quota.usage -> Number of bytes used.
        // quota.quota -> Maximum number of bytes available.
        const percentageUsed = (quota.usage / quota.quota) * 100;
        this.quota = this.$t("storageQuota.message", {
          used: this.$number2fileSize(quota.usage),
          usedPercentage: percentageUsed.toFixed(2),
          free: this.$number2fileSize(quota.quota)
        });
      }
    },
  }
}
</script>
